import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_Watching           from './Watching'
  
// Charts 
import lmx_localData          from '../primitives/localData'
import lmx_LocalValues        from './set_LocalValues'
import lmx_draw_Forms         from './draw_Forms'


export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_localData,
    lmx_Watching,

    lmx_LocalValues,
    lmx_draw_Forms,
  ],

}
